import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import useDimensions from 'react-use-dimensions';
import { useChangeAwareLayoutEffect } from 'use-change-aware-effect';

const maxWidth = 180;
const Desc = styled.div`
  flex-grow: 2;
  font: ${props => props.theme.fontWeightDccc} 14px/16.8px ${props => props.theme.fontFamilyBody};
  color: ${props => props.theme.bodyColor};
  text-transform: uppercase;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  & > span {
    white-space: nowrap;
  }

  & > span:nth-child(2) {
    overflow: hidden;
    text-overflow: ellipsis;
    width: ${maxWidth}px;
  }
`;

export default function FundNameTwoLines({ text }) {
  const [index, setIndex] = React.useState(text.length);
  const [setRef, { width }] = useDimensions();
  const lines = [text.substring(0, index), text.substring(index + 1)];

  useChangeAwareLayoutEffect(({ did }) => {
    if (did.width.change && width > maxWidth) {
      const i = lines[0].lastIndexOf(' ');
      if (i > 0) {
        setIndex(i);
        window.dispatchEvent(new Event('resize'));
      }
    }
  }, { width, lines });

  return (
    <Desc>
      <span key={index} ref={setRef}>{lines[0]}</span>
      {!!lines[1].length && <span>{lines[1]}</span>}
    </Desc>
  );
}

FundNameTwoLines.propTypes = { text: PropTypes.string.isRequired };
